import { useQuery } from "react-query";
import { getProdCodeListByCarrierId } from "../../../../actions/CarrierAgreementMgmt/ProducerCodeConfig";
import { toast } from "../../../../components/toastNotification";

export const useGetProducerCodeListByCarrierId = (args) => {
  return useQuery(
    ["ProducerCodeListByCarrierId", args],
    () => getProdCodeListByCarrierId(args),
    {
      refetchOnWindowFocus: false,
      enabled: args ? true : false,
      onSuccess: (res) => {
        if (res) {
          if (res.errors) {
            toast.fire(
              "Server Error",
              "Cannot Get Producer Code Data",
              "error"
            );
          } else {
            res.map((responseData) => {
              return {
                ...responseData,
              };
            });
          }
        } else {
          toast.fire("No Data:", "No avaible data to display.", "info");
        }
      },
    }
  );
};
